import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { ReactEditor, TemplateStatusChip, EditIcon, Grid, Typography, Divider, Button, SpellcheckIcon, MouseOverPopover, makeStyles, ItemCard, Dialog, move, DialogTemplateItem, DialogTemplateEditTags, ViewColumnIcon, Chip } from "../../..";
import { Link } from "react-router-dom";
import PublishIcon from "@material-ui/icons/Publish";
import SubjectIcon from "@material-ui/icons/Subject";
import uuidv1 from "uuid/v1";
var useStyles = makeStyles(function (theme) {
  return {
    flexCenter: {
      display: "flex",
      "align-items": "center"
    },
    itemEdit: {
      display: "flex",
      alignItems: "center"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    showDetails: {
      display: "flex",
      "justify-content": "space-between"
    }
  };
});
var TemplatesTemplateLanguage = forwardRef(function (props, ref) {
  // console.log("props template language -> ", props);
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      itemSelected = _useState2[0],
      setItemSelected = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogDeleteItem = _useState4[0],
      setOpenDialogDeleteItem = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDetails = _useState6[0],
      setShowDetails = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openHandleEditTags = _useState8[0],
      setOpenHandleEditTags = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openDialogTemplateItem = _useState10[0],
      setOpenDialogTemplateItem = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openDialogEditTemplateItem = _useState12[0],
      setOpenDialogEditTemplateItem = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      variantDialogTemplateItem = _useState14[0],
      setVariantDialogTemplateItem = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      dataDialogTemplateItem = _useState16[0],
      setDataDialogTemplateItem = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      dataDialogEditTemplateItem = _useState18[0],
      setDataDialogEditTemplateItem = _useState18[1];

  var classes = useStyles();
  useImperativeHandle(ref, function () {
    return {
      openDialogEditTask: function openDialogEditTask(task) {
        handleSetDataEditItem(task);
      }
    };
  }); // show/Hide Course Details

  var handleShowDetails = function handleShowDetails() {
    return setShowDetails(!showDetails);
  }; // HANDLE SET DATA EDIT ITEM


  var handleSetDataEditItem = function handleSetDataEditItem(task) {
    setDataDialogEditTemplateItem(props.language.phases.find(function (item) {
      return item.key === task;
    }));
    setOpenDialogEditTemplateItem(!openDialogEditTemplateItem); // setOpenDialogEditTemplateItem(true);
  }; // HANDLE EDIT ITEM


  var handleModalDialogEditTemplateItem = function handleModalDialogEditTemplateItem(keyToCheck) {
    if (keyToCheck) {
      if (openDialogEditTemplateItem === false) {
        // console.log("value key selected", keyToCheck);
        var item = props.language.phases.find(function (_item) {
          return _item.key === keyToCheck;
        }); // console.log("item finded", item);

        if (item.downloaded === false) {
          // console.log("handle to downloadTask");
          props.handleDownloadTask(keyToCheck, props.tab);
        } else {
          setDataDialogEditTemplateItem(props.language.phases.find(function (item) {
            return item.key === keyToCheck;
          }));
          setOpenDialogEditTemplateItem(!openDialogEditTemplateItem);
        }
      } else {
        setOpenDialogEditTemplateItem(!openDialogEditTemplateItem);
      }
    } else {
      setOpenDialogEditTemplateItem(!openDialogEditTemplateItem);
    }
  }; // HANDLE MODAL ITEM


  var handleModalDialogTemplateItem = function handleModalDialogTemplateItem() {
    setOpenDialogTemplateItem(!openDialogTemplateItem);
  }; // HANDLE MODAL ITEM


  var handleModalDialogDeleteItem = function handleModalDialogDeleteItem() {
    setOpenDialogDeleteItem(!openDialogDeleteItem);
  }; // HANDLE MODAL TAGS


  var handleModalEditTags = function handleModalEditTags() {
    // console.log("handle button Modal edit tags clicked");
    setOpenHandleEditTags(!openHandleEditTags);
  }; // HANDLE BUTTON ITEMCARD ADD


  var itemButtonAddHandler = function itemButtonAddHandler(key) {
    setItemSelected(key);
    setDataDialogTemplateItem({
      parent: key,
      order: 0,
      key: uuidv1(),
      children: [],
      extraFields: []
    });
    setVariantDialogTemplateItem("add");
    setOpenDialogTemplateItem(true);
  }; // HANDLE BUTTON ITEMCARD EDIT


  var itemButtonEditHandler = function itemButtonEditHandler(key) {
    setItemSelected(key);
    handleModalDialogEditTemplateItem(key);
  }; // HANDLE BUTTON ITEMCARD DELETE


  var itemButtonDeleteHandler = function itemButtonDeleteHandler(key) {
    setItemSelected(key);
    setOpenDialogDeleteItem(true);
  };
  /* -------------- ACTIONS ITEM -------------- */
  // MOVE UP ITEM


  var itemButtonUpHandler = function itemButtonUpHandler(key) {
    var itemToEdit;

    var auxPhases = _toConsumableArray(props.language.phases);

    var index = auxPhases.findIndex(function (item) {
      return item.key === key;
    });
    var idParent = auxPhases[index].parent;
    var indexParent = auxPhases.findIndex(function (item) {
      return item.key === idParent;
    });
    var indexChildren = auxPhases[indexParent].children.findIndex(function (item) {
      return item === key;
    });
    auxPhases[indexParent].children = move(auxPhases[indexParent].children, indexChildren, indexChildren - 1); // Identify item parent to edit

    itemToEdit = auxPhases[indexParent];
    props.handleEditItem(itemToEdit, props.tab);
  }; // MOVE DOWN ITEM


  var itemButtonDownHandler = function itemButtonDownHandler(key) {
    var itemToEdit;

    var auxPhases = _toConsumableArray(props.language.phases);

    var index = auxPhases.findIndex(function (item) {
      return item.key === key;
    });
    var idParent = auxPhases[index].parent;
    var indexParent = auxPhases.findIndex(function (item) {
      return item.key === idParent;
    });
    var indexChildren = auxPhases[indexParent].children.findIndex(function (item) {
      return item === key;
    });
    auxPhases[indexParent].children = move(auxPhases[indexParent].children, indexChildren, indexChildren + 1); // Identify item parent to edit

    itemToEdit = auxPhases[indexParent];
    props.handleEditItem(itemToEdit, props.tab);
  }; // DELETE ITEM


  var handleDeleteItem = function handleDeleteItem() {
    handleModalDialogDeleteItem();
    props.handleDeleteItem(itemSelected, props.tab);
  }; // SUBMIT DIALOG ITEM


  var submitItem = function submitItem(data, variant) {
    switch (variant) {
      case "add":
        handleModalDialogTemplateItem();
        props.handleAddItem(data, props.tab);
        break;

      case "edit":
        handleModalDialogEditTemplateItem();
        props.handleEditItem(data, props.tab);
        break;

      default:
        break;
    }
  };
  /* --------------- RECURSIVE FUNCTIONS --------------- */
  // RECURSIVE FUNCTION TO PAINT ITEMS


  var rTaskRender = function rTaskRender(item, isParent, tabs, isFirst, isInside, isLast) {
    return /*#__PURE__*/React.createElement(ItemCard, {
      id: item.key,
      key: item.key,
      isAdd: true,
      isEditable: isParent ? false : true,
      isDelete: tabs > 0,
      title: item.name,
      itemAddClicked: itemButtonAddHandler,
      itemEditClicked: itemButtonEditHandler,
      itemDeleteClicked: itemButtonDeleteHandler,
      itemUpClicked: itemButtonUpHandler,
      itemDownClicked: itemButtonDownHandler,
      isFirst: isFirst,
      isInside: isInside,
      isLast: isLast,
      variant: "item-checklist"
    }, /*#__PURE__*/React.createElement("ul", null, item.children.map(function (_item, index, array) {
      if (index === 0 && array.length > 1) {
        return rTaskRender(props.language.phases.find(function (__item) {
          return _item === __item.key;
        }), false, tabs + 1, true, false, false);
      } else if (index > 0 && index < array.length - 1) {
        return rTaskRender(props.language.phases.find(function (__item) {
          return _item === __item.key;
        }), false, tabs + 1, false, true, false);
      } else if (index === array.length - 1 && array.length > 1) {
        return rTaskRender(props.language.phases.find(function (__item) {
          return _item === __item.key;
        }), false, tabs + 1, false, false, true);
      } else {
        return rTaskRender(props.language.phases.find(function (__item) {
          return _item === __item.key;
        }), false, tabs + 1);
      }
    })));
  }; // RENDER PHASES


  var renderPhases = function renderPhases() {
    var contentPhases = [];
    contentPhases.push(rTaskRender(props.language.phases.find(function (item) {
      return item.key === "plan";
    }), true, 0, false, false, false));
    contentPhases.push(rTaskRender(props.language.phases.find(function (item) {
      return item.key === "docheck";
    }), true, 0, false, false, false));
    contentPhases.push(rTaskRender(props.language.phases.find(function (item) {
      return item.key === "close";
    }), true, 0, false, false, false));
    return contentPhases;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogTemplateEditTags, {
    tags: props.language.tags,
    data: props.language.tags.map(function (tag) {
      return {
        label: tag,
        value: tag
      };
    }),
    open: openHandleEditTags,
    onClose: handleModalEditTags,
    onSubmit: function onSubmit(tags) {
      return props.handleSubmitEditTagsLanguage(tags.tags, props.tab);
    }
  }), /*#__PURE__*/React.createElement(DialogTemplateItem, {
    open: openDialogTemplateItem,
    onClose: handleModalDialogTemplateItem,
    variant: variantDialogTemplateItem,
    data: dataDialogTemplateItem,
    submitItem: submitItem
  }), /*#__PURE__*/React.createElement(DialogTemplateItem, {
    open: openDialogEditTemplateItem,
    onClose: handleModalDialogEditTemplateItem,
    variant: "edit",
    data: dataDialogEditTemplateItem,
    submitItem: submitItem
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openDialogDeleteItem,
    onClose: handleModalDialogDeleteItem,
    id: "modal-confirm-delete-task",
    title: "Do you really want to remove this task?",
    text: "If you remove it, you can't get it back. You also lose all the task children.",
    onSubmit: handleDeleteItem,
    submit: "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalDialogDeleteItem,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined"
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: "16px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8,
    className: classes.flexCenter
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, props.language.name, /*#__PURE__*/React.createElement(EditIcon, {
    style: {
      color: "#ffe082",
      marginLeft: "8px",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return props.handleModalEditLanguage(props.tab);
    }
  })), /*#__PURE__*/React.createElement(TemplateStatusChip, {
    status: props.language.status,
    style: {
      "margin-left": "20px"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center"
    }
  }, props.tab !== "es" && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    style: {
      margin: "8px",
      marginRight: "36px"
    },
    onClick: function onClick() {
      return props.handleModalDeleteLanguage(props.tab);
    }
  }, "Delete"), /*#__PURE__*/React.createElement(Button, {
    variant: props.language.edited ? "contained" : "outlined",
    disabled: props.language.edited ? false : true,
    color: "primary",
    onClick: function onClick() {
      return props.handleSaveLanguage(props.tab);
    },
    style: {
      margin: "8px"
    }
  }, props.language.edited ? "SAVE" : "SAVED"), /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: props.language.reviewed ? "REVIEWED" : "REVIEW"
  }, /*#__PURE__*/React.createElement(SpellcheckIcon, {
    disabled: props.language.reviewed,
    fontSize: "large",
    onClick: function onClick() {
      return props.handleReviewLanguage(props.tab);
    },
    style: {
      margin: "8px",
      color: !props.language.reviewed ? "#ffe082" : "#77ffb5"
    }
  })), props.status !== "building" && /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: props.language.status === "draft" ? "PUBLISH LANGUAGE" : "DRAFT LANGUAGE"
  }, /*#__PURE__*/React.createElement(PublishIcon, {
    fontSize: "large",
    onClick: function onClick() {
      return props.handleChangeStatusLanguage(props.tab, props.language.status);
    },
    style: {
      margin: "8px",
      color: props.language.status === "draft" ? "#ffe082" : props.language.status === "published" ? "#77ffb5" : "#ff0000"
    }
  }))))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.language.description, /*#__PURE__*/React.createElement(EditIcon, {
    style: {
      color: "#ffe082",
      marginLeft: "8px",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return props.handleModalEditLanguage(props.tab);
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.itemEdit
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Tags"), /*#__PURE__*/React.createElement(EditIcon, {
    style: {
      color: "#ffe082",
      margin: "8px"
    },
    onClick: handleModalEditTags
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.language.tags ? props.language.tags.map(function (tag) {
    return /*#__PURE__*/React.createElement(Chip, {
      label: tag,
      className: classes.chip
    });
  }) : "Undefined"))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "32px 0"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11,
    md: 12
  }, /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: showDetails ? "Hide details" : "Show details"
  }, /*#__PURE__*/React.createElement(SubjectIcon, {
    fontSize: "default",
    color: showDetails ? "primary" : "inherit",
    onClick: handleShowDetails
  })), showDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Details"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Here you can explain some details about the template or the best practice. Maybe is not necessary in templates but would provide a good description for franchises in Best Practices")), /*#__PURE__*/React.createElement("div", {
    className: classes.showDetails
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(ReactEditor, {
    handleEditorChange: function handleEditorChange(content, html) {
      return props.handleDetailsEditorChangeLanguage(content, html, props.tab);
    },
    editorState: props.language.detailsEditorState
  }))))), !showDetails && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, renderPhases()));
});
export { TemplatesTemplateLanguage };